// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/generation_sales_plan_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { JepxSpotPortion, PlanConsistencyStatus, PlanSourceType, PlanSubmissionStatus, PlanTimeframe } from "../../bfftypes/v1/plan_submission_pb";
import { file_bfftypes_v1_plan_submission } from "../../bfftypes/v1/plan_submission_pb";
import type { PlanSlot } from "./procurement_plan_model_pb";
import { file_bffuser_v1_procurement_plan_model } from "./procurement_plan_model_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/generation_sales_plan_model.proto.
 */
export const file_bffuser_v1_generation_sales_plan_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_plan_submission, file_bffuser_v1_procurement_plan_model, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * GenerationSalesPlanRow represents a single row in the generation-sales
 * plan list table.
 *
 * @generated from message bffuser.v1.GenerationSalesPlanRow
 */
export type GenerationSalesPlanRow = Message<"bffuser.v1.GenerationSalesPlanRow"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Planning horizon.
   *
   * @generated from field: bfftypes.v1.PlanTimeframe timeframe = 2;
   */
  timeframe: PlanTimeframe;

  /**
   * Start date of the target period covered by this submission.
   *
   * @generated from field: google.type.Date target_period_start_date = 3;
   */
  targetPeriodStartDate?: Date;

  /**
   * Supply area this submission is bound to.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * OCCTO BG code of the balancing group.
   *
   * @generated from field: string bg_code = 5;
   */
  bgCode: string;

  /**
   * Display name of the balancing group. Absent when the BG master record
   * has been deleted.
   *
   * @generated from field: optional string bg_name = 6;
   */
  bgName?: string;

  /**
   * Current processing status as reported by the OCCTO portal.
   *
   * @generated from field: bfftypes.v1.PlanSubmissionStatus status = 7;
   */
  status: PlanSubmissionStatus;

  /**
   * Submission version number. Starts at 1 and increments on each
   * re-submission.
   *
   * @generated from field: int32 version = 8;
   */
  version: number;

  /**
   * Timestamp at which the plan XML file was created.
   *
   * @generated from field: google.protobuf.Timestamp file_created_at = 9;
   */
  fileCreatedAt?: Timestamp;

  /**
   * Timestamp at which the plan was submitted to the OCCTO portal.
   * Absent when the plan has not been submitted yet.
   *
   * @generated from field: optional google.protobuf.Timestamp submitted_at = 10;
   */
  submittedAt?: Timestamp;

  /**
   * 整合ステータス of the plan this row belongs to (plan-common.md §一覧テーブルの
   * 「整合ステータス」列, AC-PGL-006b). Pass-through of
   * internalapi.v1.PlanSubmissionSummaryView.consistency_status; every row of
   * one plan carries the same value, regardless of the FIT / FIP tab filter.
   * The backend always sets a value other than UNSPECIFIED (kinds without a
   * consistency judgment are NOT_EVALUATED); the frontend shows UNSPECIFIED
   * like NOT_EVALUATED. Field number is the next free one (this message
   * does not carry internalapi fields 11-18).
   *
   * @generated from field: bfftypes.v1.PlanConsistencyStatus consistency_status = 11;
   */
  consistencyStatus: PlanConsistencyStatus;

  /**
   * 事業者コードが OCCTO 呼び出し回数上限 (0102) で受付照合を止めている間、
   * 提出済 / 受領確認待ちの処理中で true (AC-PLC-058)。
   * internalapi.v1.PlanSubmissionSummaryView.receipt_check_suspended_by_call_limit
   * の pass-through。Field number is the next free one.
   *
   * @generated from field: bool receipt_check_suspended_by_call_limit = 12;
   */
  receiptCheckSuspendedByCallLimit: boolean;

  /**
   * 最終更新日時 (AC-PLC-001 / AC-PLC-005) — pass-through of
   * internalapi.v1.PlanSubmissionSummaryView.last_updated_at. Field number is the
   * next free one.
   *
   * @generated from field: google.protobuf.Timestamp last_updated_at = 13;
   */
  lastUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.GenerationSalesPlanRow.
 * Use `create(GenerationSalesPlanRowSchema)` to create a new message.
 */
export const GenerationSalesPlanRowSchema: GenMessage<GenerationSalesPlanRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_model, 0);

/**
 * GenerationSalesPlanGenerationRow is a single per-BG generation breakdown
 * row (発電BGごとの発電量行) within a GenerationSalesPlanDetail. The id field
 * is the DB internal surrogate key and is present for display reference
 * only — it must NOT be sent back in SubmitGenerationSalesPlan requests
 * because the backend performs a full replacement (delete-then-insert) on
 * every save.
 *
 * @generated from message bffuser.v1.GenerationSalesPlanGenerationRow
 */
export type GenerationSalesPlanGenerationRow = Message<"bffuser.v1.GenerationSalesPlanGenerationRow"> & {
  /**
   * DB internal surrogate key. Present for reference only; not used in
   * mutations (full replacement strategy).
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * OCCTO BG code of the generation balancing group.
   *
   * @generated from field: string generation_bg_code = 2;
   */
  generationBgCode: string;

  /**
   * Display name of the generation balancing group. Absent when the BG
   * master record has been deleted.
   *
   * @generated from field: optional string generation_bg_name = 3;
   */
  generationBgName?: string;

  /**
   * 48 ordered slots for the planning day (index 0 = 00:00, index 47 = 23:30).
   * Always exactly 48 elements when returned from the backend.
   *
   * @generated from field: repeated bffuser.v1.PlanSlot slots = 4;
   */
  slots: PlanSlot[];
};

/**
 * Describes the message bffuser.v1.GenerationSalesPlanGenerationRow.
 * Use `create(GenerationSalesPlanGenerationRowSchema)` to create a new message.
 */
export const GenerationSalesPlanGenerationRowSchema: GenMessage<GenerationSalesPlanGenerationRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_model, 1);

/**
 * GenerationSalesPlanBreakdownRow is a single breakdown row (取引先別内訳行)
 * within a GenerationSalesPlanDetail, used for both sales_values and
 * procurement_values. The id field is the DB internal surrogate key and is
 * present for display reference only — it must NOT be sent back in
 * SubmitGenerationSalesPlan requests because the backend performs a full
 * replacement (delete-then-insert) on every save.
 *
 * @generated from message bffuser.v1.GenerationSalesPlanBreakdownRow
 */
export type GenerationSalesPlanBreakdownRow = Message<"bffuser.v1.GenerationSalesPlanBreakdownRow"> & {
  /**
   * DB internal surrogate key. Present for reference only; not used in
   * mutations (full replacement strategy).
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Source type of this breakdown row (e.g. BG bilateral, JEPX spot).
   * Provisional value domain — see residual issue #890.
   *
   * @generated from field: bfftypes.v1.PlanSourceType source_type = 2;
   */
  sourceType: PlanSourceType;

  /**
   * OCCTO 取引相手コード / counterparty BG code (JP06366). Market sources (JEPX
   * spot / intraday) carry the institutional code (JSPT3 / J1HR3); 他社 bilateral
   * rows carry the counterparty BG code.
   *
   * @generated from field: optional string counterparty_code = 3;
   */
  counterpartyCode?: string;

  /**
   * Display name of the counterparty. For JEPX スポット調達 it is the 区分名
   * (調達先未定分 / 相対契約分); for 他社 the trading-partner-master 略称 when
   * the code resolves to one partner, otherwise the name recorded on the plan.
   * Absent when no name is available (the plan master's 取引先コード名称 was
   * blank, or the 他社 BG master record was deleted).
   *
   * @generated from field: optional string counterparty_name = 4;
   */
  counterpartyName?: string;

  /**
   * Contract identifier. Absent when not applicable.
   *
   * @generated from field: optional string contract_id = 5;
   */
  contractId?: string;

  /**
   * 48 ordered slots for the planning day (index 0 = 00:00, index 47 = 23:30).
   * Always exactly 48 elements when returned from the backend.
   *
   * @generated from field: repeated bffuser.v1.PlanSlot slots = 6;
   */
  slots: PlanSlot[];

  /**
   * JEPX スポット調達行の 調達先未定分 / 相対契約分 区分。販売スポット・時間前・他社行は
   * UNSPECIFIED。詳細画面が counterparty_name 文字列照合に依存せず 2 列を振り分ける信号。
   *
   * @generated from field: bfftypes.v1.JepxSpotPortion jepx_spot_portion = 7;
   */
  jepxSpotPortion: JepxSpotPortion;
};

/**
 * Describes the message bffuser.v1.GenerationSalesPlanBreakdownRow.
 * Use `create(GenerationSalesPlanBreakdownRowSchema)` to create a new message.
 */
export const GenerationSalesPlanBreakdownRowSchema: GenMessage<GenerationSalesPlanBreakdownRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_model, 2);

/**
 * GenerationSalesPlanPreviousSubmitted carries the 48-slot values of the
 * plan's 前回受理値 (the greatest earlier ACCEPTED / INCONSISTENT version of the
 * same plan; see previous_submitted). Used by the frontend to
 * compute and render per-cell diff highlights (前回差分表示).
 *
 * @generated from message bffuser.v1.GenerationSalesPlanPreviousSubmitted
 */
export type GenerationSalesPlanPreviousSubmitted = Message<"bffuser.v1.GenerationSalesPlanPreviousSubmitted"> & {
  /**
   * Timestamp at which the previous version was submitted.
   *
   * @generated from field: google.protobuf.Timestamp submitted_at = 1;
   */
  submittedAt?: Timestamp;

  /**
   * Per-BG generation breakdown rows from the previous submission.
   *
   * @generated from field: repeated bffuser.v1.GenerationSalesPlanGenerationRow generation_values = 2;
   */
  generationValues: GenerationSalesPlanGenerationRow[];

  /**
   * Sales breakdown rows from the previous submission.
   *
   * @generated from field: repeated bffuser.v1.GenerationSalesPlanBreakdownRow sales_values = 3;
   */
  salesValues: GenerationSalesPlanBreakdownRow[];

  /**
   * Procurement breakdown rows from the previous submission.
   *
   * @generated from field: repeated bffuser.v1.GenerationSalesPlanBreakdownRow procurement_values = 4;
   */
  procurementValues: GenerationSalesPlanBreakdownRow[];
};

/**
 * Describes the message bffuser.v1.GenerationSalesPlanPreviousSubmitted.
 * Use `create(GenerationSalesPlanPreviousSubmittedSchema)` to create a new message.
 */
export const GenerationSalesPlanPreviousSubmittedSchema: GenMessage<GenerationSalesPlanPreviousSubmitted> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_model, 3);

/**
 * GenerationSalesPlanDetail is the full detail payload returned by
 * GetGenerationSalesPlanDetail. It aggregates the plan header, per-BG
 * generation values, sales / procurement breakdown rows, and optionally the
 * previous submitted version for diff display.
 *
 * Aggregate totals (発電合計 / 販売合計 / 調達合計) are intentionally
 * omitted; the frontend computes them from the slot arrays.
 *
 * @generated from message bffuser.v1.GenerationSalesPlanDetail
 */
export type GenerationSalesPlanDetail = Message<"bffuser.v1.GenerationSalesPlanDetail"> & {
  /**
   * UUID surrogate primary key.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Planning horizon.
   *
   * @generated from field: bfftypes.v1.PlanTimeframe timeframe = 2;
   */
  timeframe: PlanTimeframe;

  /**
   * Start date of the target period covered by this submission.
   *
   * @generated from field: google.type.Date target_period_start_date = 3;
   */
  targetPeriodStartDate?: Date;

  /**
   * Supply area this submission is bound to.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * OCCTO BG code of the submission entity (plan submitter).
   *
   * @generated from field: string submission_entity_code = 5;
   */
  submissionEntityCode: string;

  /**
   * Display name of the submission entity. Absent when the BG master
   * record has been deleted.
   *
   * @generated from field: optional string submission_entity_name = 6;
   */
  submissionEntityName?: string;

  /**
   * Current processing status.
   *
   * @generated from field: bfftypes.v1.PlanSubmissionStatus status = 7;
   */
  status: PlanSubmissionStatus;

  /**
   * Submission version number. Starts at 1 and increments on each
   * re-submission.
   *
   * @generated from field: int32 version = 8;
   */
  version: number;

  /**
   * Timestamp at which the plan XML file was created.
   *
   * @generated from field: google.protobuf.Timestamp file_created_at = 9;
   */
  fileCreatedAt?: Timestamp;

  /**
   * Timestamp at which the plan was submitted to the OCCTO portal.
   * Absent when the plan has not been submitted yet.
   *
   * @generated from field: optional google.protobuf.Timestamp submitted_at = 10;
   */
  submittedAt?: Timestamp;

  /**
   * Per-BG generation breakdown rows (発電BGごとの発電量). Empty when no
   * rows exist.
   *
   * @generated from field: repeated bffuser.v1.GenerationSalesPlanGenerationRow generation_values = 11;
   */
  generationValues: GenerationSalesPlanGenerationRow[];

  /**
   * Sales breakdown rows (取引先別販売内訳). Empty when no rows exist.
   *
   * @generated from field: repeated bffuser.v1.GenerationSalesPlanBreakdownRow sales_values = 12;
   */
  salesValues: GenerationSalesPlanBreakdownRow[];

  /**
   * Procurement breakdown rows (取引先別調達内訳). Empty when no rows exist.
   *
   * @generated from field: repeated bffuser.v1.GenerationSalesPlanBreakdownRow procurement_values = 13;
   */
  procurementValues: GenerationSalesPlanBreakdownRow[];

  /**
   * Values of the 前回受理値: among the versions of the same plan (the 単日
   * 当日 / 翌日 / 翌々日 sections are one plan) with a smaller version number,
   * the greatest one in ACCEPTED or INCONSISTENT (受領済・不整合). Absent when
   * no such version exists.
   *
   * @generated from field: optional bffuser.v1.GenerationSalesPlanPreviousSubmitted previous_submitted = 14;
   */
  previousSubmitted?: GenerationSalesPlanPreviousSubmitted;

  /**
   * Optimistic-lock baseline for mutations.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */
  updatedAt?: Timestamp;

  /**
   * 事業者コードが OCCTO 呼び出し回数上限 (0102) で受付照合を止めている間、
   * 提出済 / 受領確認待ちの処理中で true (AC-PLC-058)。
   * internalapi.v1.PlanSubmissionDetailView.receipt_check_suspended_by_call_limit
   * の pass-through。Field number is the next free one.
   *
   * @generated from field: bool receipt_check_suspended_by_call_limit = 16;
   */
  receiptCheckSuspendedByCallLimit: boolean;

  /**
   * 表示中の版の提出期限 (AC-PLC-020-1)。未設定 = 期限を出さない断面 (当日・週間以降)。
   * internalapi.v1.PlanSubmissionDetailView.submission_deadline_at の pass-through。
   *
   * @generated from field: optional google.protobuf.Timestamp submission_deadline_at = 17;
   */
  submissionDeadlineAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.GenerationSalesPlanDetail.
 * Use `create(GenerationSalesPlanDetailSchema)` to create a new message.
 */
export const GenerationSalesPlanDetailSchema: GenMessage<GenerationSalesPlanDetail> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_generation_sales_plan_model, 4);

/**
 * GenerationSalesPlanTab represents the plan sub-kind tabs on the
 * generation-sales plan list screen (発電販売 / FIT / FIP).
 *
 * @generated from enum bffuser.v1.GenerationSalesPlanTab
 */
export enum GenerationSalesPlanTab {
  /**
   * @generated from enum value: GENERATION_SALES_PLAN_TAB_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GENERATION_SALES_PLAN_TAB_NORMAL = 1;
   */
  NORMAL = 1,

  /**
   * @generated from enum value: GENERATION_SALES_PLAN_TAB_FIT = 2;
   */
  FIT = 2,

  /**
   * @generated from enum value: GENERATION_SALES_PLAN_TAB_FIP = 3;
   */
  FIP = 3,
}

/**
 * Describes the enum bffuser.v1.GenerationSalesPlanTab.
 */
export const GenerationSalesPlanTabSchema: GenEnum<GenerationSalesPlanTab> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_generation_sales_plan_model, 0);

